import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@ordering/utils/styling';

const bodyVariants = cva('font-inter tracking-[-0.22px]', {
  variants: {
    variant: {
      s: 'text-[14px] leading-[20px]',
      m: 'text-[16px] leading-[22px]',
      l: 'text-[20px] leading-[24px]',
      xlcustom: 'text-[48px] leading-[56px]',
    },
    weight: {
      regular: 'font-regular',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    // see tailwind.config.js for exact weight
  },
  defaultVariants: {
    variant: 'm',
    weight: 'regular',
  },
});

export interface BodyProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof bodyVariants> {
  asChild?: boolean;
  as?: React.ElementType;
}

const Body = React.forwardRef<HTMLElement, BodyProps>(
  ({ className, variant, weight, asChild = false, as = 'p', children, ...props }, ref) => {
    const Comp = asChild ? Slot : as;

    return (
      <Comp className={cn(bodyVariants({ variant, weight, className }))} ref={ref} {...props}>
        {children}
      </Comp>
    );
  }
);
Body.displayName = 'Body';

export { Body, bodyVariants };
